"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.marketplaceReportSearchParams = exports.marketplaceReportColumnsCreator = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const date_fns_1 = require("date-fns");
const constants_1 = require("@dzambalaorg/constants");
const mui_scanner_1 = require("@dzambalaorg/mui-scanner");
const exchange_1 = require("@framework/exchange");
const types_1 = require("../../../../types");
// prettier-ignore
const marketplaceReportColumnsCreator = (formatMessage) => [
    {
        field: "tokenId",
        headerName: formatMessage({ id: "form.labels.id" }),
        sortable: true,
        flex: 0
    },
    {
        field: "title",
        headerName: formatMessage({ id: "form.labels.title" }),
        sortable: false,
        flex: 1,
        minWidth: 200
    },
    {
        field: "account",
        headerName: formatMessage({ id: "form.labels.address" }),
        sortable: false,
        renderCell: (params) => {
            return ((0, jsx_runtime_1.jsx)(mui_scanner_1.AddressLink, { address: params.value, length: 18 }));
        },
        flex: 1,
        minWidth: 200
    },
    {
        field: "price",
        headerName: formatMessage({ id: "form.labels.price" }),
        sortable: true,
        valueFormatter: (value) => (0, exchange_1.formatItem)({ id: 0, components: value }),
        flex: 1,
        minWidth: 100
    },
    {
        field: "createdAt",
        headerName: formatMessage({ id: "form.labels.createdAt" }),
        sortable: true,
        valueFormatter: (value) => (0, date_fns_1.format)((0, date_fns_1.parseISO)(value), constants_1.humanReadableDateTimeFormat),
        flex: 1,
        minWidth: 160
    },
];
exports.marketplaceReportColumnsCreator = marketplaceReportColumnsCreator;
const startTimestamp = (0, date_fns_1.startOfMonth)((0, date_fns_1.subMonths)(new Date(), 1)).toISOString();
const endTimestamp = (0, date_fns_1.endOfMonth)((0, date_fns_1.addMonths)(new Date(), 1)).toISOString();
const commonParams = {
    query: "",
    contractIds: [],
    templateIds: [],
};
const marketplaceReportSearchParams = profile => ({
    [types_1.ServiceType.ADMIN]: {
        ...commonParams,
        startTimestamp,
        endTimestamp,
    },
    [types_1.ServiceType.OFFICE]: {
        merchantId: profile.merchantId,
        ...commonParams,
        startTimestamp,
        endTimestamp,
    },
});
exports.marketplaceReportSearchParams = marketplaceReportSearchParams;
//# sourceMappingURL=schemas.js.map